import React, { useEffect, useState } from 'react';
import {
  ActionDiv,
  ButtonsDiv,
  Divider,
  Header,
  ImageDiv,
  ImgLabel,
  LinkItem,
  LoggedDiv,
  LogoutModal,
  LowerLinks,
  MyAccount,
  TitleDiv,
  UpperButtons,
  UserDiv,
  VerticalDivider,
  WeatherMobile,
} from './styles';
import Button from '../../components/Buttom/Button';
import { useHistory } from 'react-router';
import { useRecoilState } from 'recoil';
import { logged } from 'features/Login/store/LoginAtom';
import photoExample from 'assets/images/examplePhoto.svg';
import myAccount from 'assets/images/myAccount.svg';
import emailIcon from 'assets/images/email.svg';
import userIcon from 'assets/images/user.svg';
import loginIcon from 'assets/images/log-in.svg';
import logoutIcon from 'assets/images/logoutIcon.svg';
import { getLocalUser, userLogout } from 'services/localStorage';
import { auth } from 'utils/firebase';
import { CircularProgress, Modal } from '@mui/material';
import { navigateBasedOnProfile } from 'utils/navigateBasedOnProfile';
import { usePortalContext } from 'common/PortalContext';
import { ConstructionOutlined } from '@mui/icons-material';
import WeatherHeaderButton from '../../components/WeatherHeaderButton/WeatherHeaderButton';

const getProfileName = (profile: string) => {
  const profileNames = {
    admin: 'Administrador',
    news: 'Imprensa',
    'news-external': 'Imprensa',
    setur: 'Secretaria do Turismo',
    'setur-market': 'Secretaria do Turismo',
    'setur-marketing': 'Secretaria do Turismo',
    'setur-fundetur': 'Secretaria do Turismo',
    'setur-attorney': 'Secretaria do Turismo',
    'setur-excursion': 'Secretaria do Turismo',
    'setur-dados': 'Secretaria do Turismo',
    tour: 'Organizador de excursão',
    'tour-pf': 'Organizador de excursão',
    'tour-pj': 'Organizador de excursão',
    'tour-admin': 'Secretaria do Turismo',
    tourist: 'Turista',
    trade: 'Trade',
  } as { [key: string]: string };
  return profileNames[profile];
};

interface Props {
  closeLanguages: () => void;
}

const TopBar = (props: Props): JSX.Element => {
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const [portalName, setPortalName] = useState('');
  const [logo, setLogo] = useState('');
  const [loggedState, setLoggedState] = useRecoilState(logged);
  const [showMyAccountHover, setShowMyAccountHover] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [userName, setUserName] = useState('Nome Sobrenome');
  const [userPhoto, setUserPhoto] = useState(photoExample);
  const [profileName, setProfileName] = useState('');
  const [navigateUser, setNavigateUser] = useState('');
  const [emailVerified, setEmailVerified] = useState(true);
  const { closeLanguages } = props;
  const path = window.location.pathname;
  const portalContext = usePortalContext();
  const OPENWEATHER_API_KEY = 'fddccc4373122035dcbea7c7c7e54af4'; // dentro do código por questões de lack de segurança no GCP *********
  const WEATHER_CITY = 'Porto Seguro';

  // const fetchPortalName = async () => {
  //   const response = await new VisualIdentityService().getPortalName();
  //   response ? setPortalName(response as unknown as string) : setPortalName('Porto Seguro');
  // };

  // const fetchLogo = async () => {
  //   const response = await new VisualIdentityService().getLogo();
  //   response ? setLogo(response as unknown as string) : setLogo(logoSVG);
  // };

  // useEffect(() => {
  //   setLoading(true);
  //   setTimeout(() => {
  //     fetchPortalName();
  //     fetchLogo();
  //   }, 500);
  //   setLoading(false);
  // }, []);

  useEffect(() => {
    const localUser = getLocalUser();

    if (localUser?.name) {
      setUserName(localUser.name);
      portalContext.setPortalUser(localUser.name);
    }
    if (localUser?.profile?.image) {
      setUserPhoto(localUser?.profile?.image);
    }
    if (localUser?.profile?.name) {
      setProfileName(getProfileName(localUser?.profile?.name));
      setNavigateUser(localUser?.profile?.name);
    }
    if (localUser?.email && typeof localUser?.emailVerified === 'boolean') {
      setEmailVerified(localUser.emailVerified);
    }
  }, [portalContext]);

  const logout = () => {
    setLoggedState(false);
    userLogout();
    auth.signOut();
    history.push('/');
    setShowModal(false);
  };

  const redirectToHome = () => {
    if (!emailVerified) return;
    history.push(navigateBasedOnProfile(navigateUser));
  };

  return (
    <Header>
      {loading ? (
        <TitleDiv>
          <CircularProgress size={60} color="primary" />
        </TitleDiv>
      ) : (
        <TitleDiv>
          {Array.isArray(portalContext.portalLogo) && portalContext.portalLogo[0] ? (
            <img src={portalContext.portalLogo[0].url as string} alt="" onClick={redirectToHome} />
          ) : (
            <img src={portalContext.portalLogo as string} alt="" onClick={redirectToHome} />
          )}

          <VerticalDivider />

          <h1 onClick={redirectToHome}>
            <span>{portalContext.portalName}</span>
          </h1>

          <WeatherMobile>
            <WeatherHeaderButton city={WEATHER_CITY} apiKey={OPENWEATHER_API_KEY} />
          </WeatherMobile>
        </TitleDiv>
      )}

      <ActionDiv onMouseEnter={() => setShowMyAccountHover(false)}>
        <div style={{ marginRight: '32px' }}>
          <WeatherHeaderButton city={WEATHER_CITY} apiKey={OPENWEATHER_API_KEY} hideOn="mobile" />
        </div>

        <ButtonsDiv onMouseLeave={() => setShowMyAccountHover(false)}>
          {!loggedState && (
            <>
              <UpperButtons>
                {/* Antigo cadastro de excursão no portal - Retirado */}
                {/* <Button onClick={() => history.push('/organizer/')} text={'ORGANIZADOR DE EXCURSÃO'} /> */}
                <Button
                  onClick={() => window.open('https://tts.vivaportoseguro.app/')}
                  text={'ORGANIZADOR DE EXCURSÃO'}
                />
                <Button onClick={() => history.push('/trade/')} text={'TRADE'} />
              </UpperButtons>

              <LowerLinks>
                <LinkItem onClick={() => history.push('/login')}>
                  <img src={loginIcon} alt="Login" />
                  Login
                </LinkItem>
                <LinkItem
                  onClick={() =>
                    path.includes('signup') ? history.push('/signup/tourist') : history.push('/login/tourist')
                  }>
                  <img src={userIcon} alt="Login" />
                  Área do Turista
                </LinkItem>
                <LinkItem onClick={() => window.open('https://webmail-seguro.com.br/', '_blank')}>
                  <img src={emailIcon} alt="Webmail" />
                  Webmail
                </LinkItem>
              </LowerLinks>
            </>
          )}
          <LoggedDiv>
            {loggedState && (
              <UserDiv>
                <ImageDiv>
                  <img src={userPhoto} alt="" onMouseEnter={() => setShowMyAccountHover(true)} />
                </ImageDiv>
                <div className="userField" onClick={() => setShowMyAccountHover(!showMyAccountHover)}>
                  <span className="userName">
                    <b>{portalContext.portalUser}</b>
                  </span>
                  <span>{profileName}</span>
                </div>
              </UserDiv>
            )}
            {showMyAccountHover && (
              <MyAccount onMouseLeave={() => setShowMyAccountHover(false)}>
                {emailVerified && (
                  <>
                    <ImgLabel onClick={() => history.push('/my-account')}>
                      <img src={myAccount} alt="Minha Conta" />
                      <span>Minha Conta</span>
                    </ImgLabel>
                    <Divider />
                  </>
                )}
                <ImgLabel onClick={() => setShowModal(true)}>
                  <img src={logoutIcon} alt="Sair" />
                  <span>Sair</span>
                </ImgLabel>
              </MyAccount>
            )}
          </LoggedDiv>
        </ButtonsDiv>
      </ActionDiv>

      <Modal open={showModal}>
        <LogoutModal>
          <h2>SAIR</h2>
          <span>Você está se desconectando de uma conta. Deseja continuar?</span>
          <div>
            <Button text="CANCELAR" onClick={() => setShowModal(false)} />
            <Button text="SAIR" onClick={logout} />
          </div>
        </LogoutModal>
      </Modal>
    </Header>
  );
};

export default TopBar;
